// SPM配置
export const spmConfig = {
  '/': {
    spmB: 'icirenaweb_home',
    pageName: '首页',
  },
  '/film': {
    spmB: 'icirenaweb_film',
    pageName: '影片页',
  },
  '/film/detail': {
    spmB: 'icirenaweb_film_detail',
    pageName: '影片详情页',
  },
  '/cinema/detail': {
    spmB: 'icirenaweb_cinema_detail',
    pageName: '影院场次页',
  },
  '/seat': {
    spmB: 'icirenaweb_seat',
    pageName: '选座页',
  },
  '/order/confirm': {
    spmB: 'icirenaweb_order_confirm',
    pageName: '确认订单页',
  },
  '/payment': {
    spmB: 'icirenaweb_payment',
    pageName: '再次支付页',
  },
  '/payment/result': {
    spmB: 'icirenaweb_payment_result',
    pageName: '订单结果页',
  },
  '/activity/detail': {
    spmB: 'icirenaweb_activity_detail',
    pageName: '活动详情页',
  },
  '/activityAndVip': {
    spmB: 'icirenaweb_activityandvip',
    pageName: '活动和VIP页',
  },
  '/agreement/list': {
    spmB: 'icirenaweb_agreement_list',
    pageName: '协议列表页',
  },
  '/agreement/privacy': {
    spmB: 'icirenaweb_agreement_privacy',
    pageName: '隐私协议页',
  },
  '/app': {
    spmB: 'icirenaweb_app',
    pageName: 'APP页',
  },
  '/card/agreement': {
    spmB: 'icirenaweb_card_agreement',
    pageName: '会员卡协议页',
  },
  '/card/changePassword': {
    spmB: 'icirenaweb_card_changepassword',
    pageName: '修改密码页',
  },
  '/card/complete': {
    spmB: 'icirenaweb_card_complete_page',
    pageName: '开卡完成页',
  },
  '/card/desc': {
    spmB: 'icirenaweb_card_desc',
    pageName: '会员卡说明页',
  },
  '/card/list': {
    spmB: 'icirenaweb_card_list',
    pageName: '会员卡列表页',
  },
  '/card/recharge': {
    spmB: 'icirenaweb_card_recharge',
    pageName: '会员卡充值页',
  },
  '/card/renew': {
    spmB: 'icirenaweb_card_renew',
    pageName: 'VIP会籍续费页',
  },
  '/card/sell': {
    spmB: 'icirenaweb_card_sell',
    pageName: '购买会员卡页',
  },
  '/card/topUp': {
    spmB: 'icirenaweb_card_topup',
    pageName: '充值页',
  },
  '/coupon/details': {
    spmB: 'icirenaweb_coupon_details',
    pageName: '优惠券详情页',
  },
  '/coupon/list': {
    spmB: 'icirenaweb_coupon_list',
    pageName: '优惠券列表页',
  },
  '/err': {
    spmB: 'icirenaweb_err',
    pageName: '错误页',
  },
  '/eventsAndParties/bookingInquiry': {
    spmB: 'icirenaweb_eventsAndParties_bookinginquiry',
    pageName: '包场查询',
  },
  '/foodAndDrink': {
    spmB: 'icirenaweb_foodanddrink',
    pageName: '餐饮页',
  },
  '/foodAndDrink/list': {
    spmB: 'icirenaweb_foodanddrink_list',
    pageName: '餐饮列表页',
  },
  '/foodAndDrink/pay': {
    spmB: 'icirenaweb_foodanddrink_pay',
    pageName: '餐饮支付页',
  },
  '/goods': {
    spmB: 'icirenaweb_goods',
    pageName: '商品页',
  },
  '/help': {
    spmB: 'icirenaweb_help',
    pageName: '帮助页',
  },
  '/mall': {
    spmB: 'icirenaweb_mall',
    pageName: '商城页',
  },
  '/membership/benefits': {
    spmB: 'icirenaweb_membership_benefits',
    pageName: '会员权益页',
  },
  '/order/list': {
    spmB: 'icirenaweb_order_list',
    pageName: '订单列表页',
  },
  '/payment/callback': {
    spmB: 'icirenaweb_payment_callback',
    pageName: '支付回调页',
  },
  '/payment/cardApply': {
    spmB: 'icirenaweb_payment_cardapply',
    pageName: '申请卡片支付页',
  },
  '/payment/index': {
    spmB: 'icirenaweb_payment_index',
    pageName: '支付首页',
  },
  '/payment/recharge': {
    spmB: 'icirenaweb_payment_recharge',
    pageName: '充值支付页',
  },
  '/payment/renew': {
    spmB: 'icirenaweb_payment_renew',
    pageName: '续费支付页',
  },
  '/point/complete': {
    spmB: 'icirenaweb_point_complete',
    pageName: '积分兑换完成页',
  },
  '/point/myPoint': {
    spmB: 'icirenaweb_point_mypoint',
    pageName: '我的积分页',
  },
  '/point/order': {
    spmB: 'icirenaweb_point_order',
    pageName: '积分订单页',
  },
  '/point/orderDetail': {
    spmB: 'icirenaweb_point_orderdetail',
    pageName: '积分订单详情页',
  },
  '/point/store': {
    spmB: 'icirenaweb_point_store',
    pageName: '积分商城页',
  },
  '/pos/detail': {
    spmB: 'icirenaweb_pos_detail',
    pageName: 'POS详情页',
  },
  '/s': {
    spmB: 'icirenaweb_s',
    pageName: '短链接页',
  },
  '/showtimes': {
    spmB: 'icirenaweb_showtimes_page',
    pageName: '电影场次页',
  },
  '/user/feedback': {
    spmB: 'icirenaweb_user_feedback',
    pageName: '用户反馈页',
  },
  '/user/index': {
    spmB: 'icirenaweb_user_index',
    pageName: '用户首页',
  },
  '/user/integral': {
    spmB: 'icirenaweb_user_integral',
    pageName: '用户积分页',
  },
  '/user/integralAnnotation': {
    spmB: 'icirenaweb_user_integralannotation',
    pageName: '积分说明页',
  },
  '/user/levelRules': {
    spmB: 'icirenaweb_user_levelrules',
    pageName: '等级规则页',
  },
  '/user/login': {
    spmB: 'icirenaweb_user_login',
    pageName: '登入页',
  },
  '/user/logoff': {
    spmB: 'icirenaweb_user_logoff',
    pageName: '用户退出页',
  },
  '/user/memberCode': {
    spmB: 'icirenaweb_user_membercode',
    pageName: '会员码页',
  },
  '/user/personal': {
    spmB: 'icirenaweb_user_personal',
    pageName: '个人信息页',
  },
  '/wechatPay': {
    spmB: 'icirenaweb_wechatpay',
    pageName: '微信支付页',
  },
  '/activity/list': {
    spmB: 'icirenaweb_activity_list_page',
    pageName: '活动列表页',
  },
};
